import log from '@mmw/logging-logger';

export default log
  .extend('services')
  .extend('core')
  .extend('trader-demo-device');
